import { Inbox } from "lucide-react";
import { Badge } from "../../../components/ui/badge";
import { cn } from "../../../lib/utils";
import { Ticket, aguardandoResposta } from "../types";
import { formatTelefone, haQuantoTempo } from "./format";

interface TicketListProps {
  tickets: Ticket[];
  selectedId: string | null;
  onSelect: (ticketId: string) => void;
  isLoading: boolean;
}

export function TicketList({ tickets, selectedId, onSelect, isLoading }: TicketListProps) {
  if (isLoading) return <p className="p-4 text-sm text-muted-foreground">Carregando…</p>;

  if (tickets.length === 0) {
    return (
      <div className="flex flex-col items-center gap-2 p-8 text-center text-sm text-muted-foreground">
        <Inbox className="h-6 w-6" />
        Nenhum atendimento aqui.
      </div>
    );
  }

  return (
    <ul className="divide-y">
      {tickets.map((t) => (
        <li key={t.ticket_id}>
          <button
            type="button"
            onClick={() => onSelect(t.ticket_id)}
            className={cn(
              "w-full px-4 py-3 text-left transition-colors hover:bg-accent",
              selectedId === t.ticket_id && "bg-accent"
            )}
          >
            <div className="flex items-center justify-between gap-2">
              <span className="flex items-center gap-2 font-medium">
                {t.status === "open" && aguardandoResposta(t) && (
                  <span className="h-2.5 w-2.5 shrink-0 rounded-full bg-blue-600" title="Mensagem nova do entregador" aria-label="Mensagem nova" />
                )}
                {formatTelefone(t.telefone)}
              </span>
              <span className="shrink-0 text-xs text-muted-foreground">{haQuantoTempo(t.updated_at)}</span>
            </div>
            <div className="mt-1 flex items-center gap-2">
              <Badge variant="outline">{t.ops}</Badge>
              {t.assigned_agent && <span className="truncate text-xs text-muted-foreground">{t.assigned_agent}</span>}
            </div>
            {t.last_message_preview && (
              <p className="mt-1 line-clamp-2 text-sm text-muted-foreground">{t.last_message_preview}</p>
            )}
          </button>
        </li>
      ))}
    </ul>
  );
}
